import React, { FC } from 'react';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface TermsItem {
  label: string;
  pairId: string;
  show?: boolean;
  descriptionItem?: DescriptionItem;
  correctBorderColor?: string;
}

export interface DescriptionItem {
  label: string;
  pairId: string;
  show?: boolean;
  termsItem?: TermsItem;
  correctBorderColor?: string;
}

export interface QuizMemoryGameStore {
  termsItems: TermsItem[];
  descriptionItems: DescriptionItem[];
}

const _useQuizMemoryGameStore = create<QuizMemoryGameStore>(
  devtools((set, get) => ({
    termsItems: [],
    descriptionItems: [],
  })) as any
);

export const MemoryGameProvider: FC<{
  termsItems: TermsItem[];
  descriptionItems: DescriptionItem[];
}> = ({ children, termsItems, descriptionItems }) => {
  _useQuizMemoryGameStore.setState({ termsItems, descriptionItems });
  return <>{children}</>;
};

export const useQuizMemoryGameStore = _useQuizMemoryGameStore;
